"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cachedRateLimit = void 0;
const ErrorWithMeta_1 = require("./ErrorWithMeta");
const luxon_1 = require("luxon");
const empty = Symbol();
function cachedRateLimit(f, options) {
    const { mode, fallback, onReject, onResolve, onError, pass_TTL, fail_TTL } = Object.assign({
        pass_TTL: { minutes: 5 },
        fail_TTL: { seconds: 30 },
    }, options);
    let result = empty;
    let nextResult = empty;
    let timeout = luxon_1.DateTime.now().minus({ seconds: 1 });
    let immediateResult = fallback;
    async function get() {
        // If the current result is within its cached period, return it
        const withinTimeout = timeout > luxon_1.DateTime.now();
        if (withinTimeout) {
            // When should we return the cached result
            if (result !== empty) {
                // If we have a result, return it
                return result;
            }
            else if (nextResult !== empty) {
                // If we don't have a result, but we have a nextResult, return it
                return nextResult;
            }
        }
        // If the nextResult is the same as the current result, then the
        //  next result is "left over" from the last generation and it
        //  needs to be triggered again.
        if (nextResult === result) {
            // Trigger an update
            const promise = f();
            nextResult = promise.then((r) => {
                // on success
                immediateResult = r;
                timeout = luxon_1.DateTime.now().plus(pass_TTL);
                result = nextResult;
                if (onResolve) {
                    try {
                        onResolve(r);
                    }
                    catch (e) {
                        onError(e);
                    }
                }
                return r;
            }, (e) => {
                // on fail
                immediateResult = fallback;
                timeout = luxon_1.DateTime.now().plus(fail_TTL);
                result = nextResult;
                if (onReject) {
                    try {
                        onReject(e);
                    }
                    catch (e) {
                        onError(e);
                    }
                }
                return fallback;
            });
        }
        if (result === empty || mode === 'await latest response') {
            // Logically we should always have next result here, but typescript doesn't know that
            if (nextResult === empty) {
                throw new ErrorWithMeta_1.ErrorWithMeta(`This shouldn't happen - but it did.`, {
                    mode,
                });
            }
            return nextResult;
        }
        return result;
    }
    if (mode === 'immediate response') {
        return function () {
            get();
            return immediateResult;
        };
    }
    return get;
}
exports.cachedRateLimit = cachedRateLimit;
//# sourceMappingURL=cachedRateLimit.js.map